import React from 'react';
import { Input, Card, CardBody, Row, Col, Form, FormGroup, FormFeedback, Spinner } from 'reactstrap';
import { Formik, Field } from 'formik';
import * as Yup from 'yup';
import { _translate as t, _Translator as translator } from "../../../../../services/core";
var MagicLogin = function MagicLogin(_ref) {
  var onSubmit = _ref.onSubmit,
    loading = _ref.loading,
    goBack = _ref.goBack;
  return /*#__PURE__*/React.createElement(Row, {
    className: "justify-content-center"
  }, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("p", {
    className: "text-center"
  }, t('magic_token_title')), /*#__PURE__*/React.createElement(Card, {
    className: "bg-white shadow border-0"
  }, /*#__PURE__*/React.createElement(CardBody, {
    className: "px-lg-5 py-lg-5"
  }, /*#__PURE__*/React.createElement("p", {
    className: "text-center"
  }, t('magic_token_subtitle')), /*#__PURE__*/React.createElement(Formik, {
    onSubmit: onSubmit,
    initialValues: {
      username: ''
    },
    validationSchema: Yup.object({
      username: Yup.string().required(translator.translate('field_required'))
    })
  }, function (_ref2) {
    var handleSubmit = _ref2.handleSubmit,
      handleBlur = _ref2.handleBlur,
      errors = _ref2.errors,
      touched = _ref2.touched;
    return /*#__PURE__*/React.createElement(Form, {
      noValidate: true,
      role: "form",
      onSubmit: handleSubmit
    }, /*#__PURE__*/React.createElement(FormGroup, {
      className: "mb-5"
    }, /*#__PURE__*/React.createElement(Input, {
      tag: Field,
      placeholder: translator.translate('magic_key'),
      name: "username",
      autoComplete: "false",
      icon: "envelope",
      onBlur: handleBlur,
      invalid: errors.username && touched.username
    }), touched.username && /*#__PURE__*/React.createElement(FormFeedback, null, errors.username)), /*#__PURE__*/React.createElement("div", {
      className: "text-center"
    }, loading ? /*#__PURE__*/React.createElement(Spinner, {
      size: "md"
    }) : /*#__PURE__*/React.createElement("button", {
      outline: true,
      className: "btn-wever bg-pink-wever",
      type: "submit"
    }, t('managerapp_submit_magic_key'))));
  }))), /*#__PURE__*/React.createElement(Row, {
    className: "mt-3"
  }, /*#__PURE__*/React.createElement(Col, {
    xs: "12",
    className: "text-center"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-secondary",
    onClick: function onClick() {
      return goBack(false);
    }
  }, /*#__PURE__*/React.createElement("small", null, t('back_to_login')))))));
};
export default MagicLogin;